export default "__VITE_ASSET__Bf7rjZ9t__"